module.exports = __webpack_public_path__ + "img/11.dirty_sink.c4bcb8ca.svg";